import { render, staticRenderFns } from "./EditModule.vue?vue&type=template&id=e3bf9ffa&"
import script from "./EditModule.vue?vue&type=script&lang=ts&"
export * from "./EditModule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports